module.exports = __webpack_public_path__ + "static/media/ic-ecommerce-card.d20ac5ff.svg";